import { basicAuthOptions, bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";

export function getClasses(start, end, language) {
	const querystring = start || language ? `?start=${start || 0}&end=${end || 30}` : "";
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/classes/learner${querystring}`, options).then(r => r.data);
}

export function getClass(classId, language) {
	const options = { ...basicAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/class/learner/${classId}`, options).then(r => r.data);
}

export function startClass(classId, language, sessionId) {
	const options = { ...bearerAuthOptions };
	const querystring = sessionId ? `?session=${sessionId}` : "";
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/class/start/${classId}${querystring}`, options);
}

export function getInProgressClasses(language) {
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/classes/inprogress`, options).then(r => r.data);
}

export function completeClassUrl(classId, email, answer, language, sessionId) {
	return `${apiUrl}/class/complete/${classId}?complete=1${
		email ? `&learner_email=${encodeURIComponent(email)}` : ""
	}${answer ? `&answer=${encodeURIComponent(answer)}` : ""}${
		language ? `&language=${encodeURIComponent(language)}` : ""
	}${sessionId ? `&session=${encodeURIComponent(sessionId)}` : ""}`;
}

export function getLiveClassesSchedule(startDate, endDate, language) {
	const options = { ...basicAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios
		.get(`${apiUrl}/classes/live?startDate=${startDate}&endDate=${endDate}`, options)
		.then(r => r.data);
}

export function getLiveClassSession(classId, sessionId, language) {
	const options = { ...basicAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios
		.get(`${apiUrl}/class/live/${classId}/session/${sessionId}`, options)
		.then(r => r.data);
}

export function registerLiveClass(
	sessionId,
	email,
	firstName,
	lastName,
	source,
	medium,
	campaign,
	content,
) {
	const options = { ...basicAuthOptions };
	return axios
		.post(
			`${apiUrl}/session/${sessionId}`,
			{ email, firstName, lastName, source, medium, campaign, content },
			options,
		)
		.then(r => r.data);
}



// WEBPACK FOOTER //
// ./src/api/class.js